export class Subscriber {

    campusId: number;
    name    : string;
    mail    : string;
    message : string;

}